module.exports = __webpack_public_path__ + "static/media/redBanner.40223cf1.png";